import React, { Suspense } from 'react'
import { Link } from 'react-router-dom'
import Breadcumb from '../../Breadcumb/Main'
import ServiceSidebar from '../ServiceSidebar/Main'
import security1 from '../../../assets/images/services/security-1-1.jpg'
import security2 from "../../../assets/images/services/security-1-2.jpg";
import { useTranslation } from 'react-i18next';

const CyberSecurity = () => {

	// const [clicked, setClicked] = useState(0);
	// const faqs = [
	// 	{
	// 		question: "Nulla eu nisi pellentesque, ultrices lorem eget, mattis dolo",
	// 		answer: "There are many variations of passages the majority have suffered alteration in some fo injected humour, or randomised words believable. Phasellus a rhoncus erat. Vivamus vel eros vitae estaliquet pellentesque vitae."
	// 	},
	// 	{
	// 		question: "Praesent nec ante sed libero tempus rutrum",
	// 		answer: "There are many variations of passages the majority have suffered alteration in some fo injected humour, or randomised words believable. Phasellus a rhoncus erat. Vivamus vel eros vitae estaliquet pellentesque vitae."
	// 	},
	// 	{
	// 		question: "Integer et mi in eros commodo bibendum",
	// 		answer: "There are many variations of passages the majority have suffered alteration in some fo injected humour, or randomised words believable. Phasellus a rhoncus erat. Vivamus vel eros vitae estaliquet pellentesque vitae."
	// 	},
	// 	{
	// 		question: "Proin commodo turpis eu leo tempus varius",
	// 		answer: "There are many variations of passages the majority have suffered alteration in some fo injected humour, or randomised words believable. Phasellus a rhoncus erat. Vivamus vel eros vitae estaliquet pellentesque vitae."
	// 	}
	// ]
  const { t } = useTranslation();
	return (
    <>
      <Suspense
        fallback={
          <div class="preloader">
            <div class="preloader__circle"></div>
          </div>
        }
      >
        <Breadcumb
          Title={t('cyber_security.breadcrumb_title')}
          Breadcumb={t('breadcrumb.services')}
        />

        <section className="section-padding--bottom section-padding--top service-details--page">
          <div className="container">
            <div className="row ">
              <div className="col-lg-8">
                <div className="service-details__image">
                  <img src={security1} alt="" />
                </div>

                <h3 className="service-details__title">{t('cyber_security.page_title')}</h3>

                <div className="service-details__content">
                  <p>{t('cyber_security.intro_p')}</p>

                  <h4>{t('cyber_security.protect_data_title')}</h4>
                  <p>{t('cyber_security.protect_data_p')}</p>

                  <h4>{t('cyber_security.secure_business_title')}</h4>
                  <p>{t('cyber_security.secure_business_p')}</p>

                  <h4>{t('cyber_security.always_here_title')}</h4>
                  <p>{t('cyber_security.always_here_p')}</p>
                </div>

                <div className="row gutter-y-30 service-details__box-wrapper">
                  <div className="col-md-6 col-sm-12">
                    <div className="service-details__box">
                      <i className="service-details__box__icon icon-consulting"></i>
                      <div className="service-details__box__content">
                        <h3 className="service-details__box__title">
                          <Link to="#">{t('common.it_consultant')}</Link>
                        </h3>
                        <p className="service-details__box__text">
                          {t('common.it_consultant_text')}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-6 col-sm-12">
                    <div className="service-details__box">
                      <i className="service-details__box__icon icon-chip"></i>
                      <div className="service-details__box__content">
                        <h3 className="service-details__box__title">
                          <Link to="#">{t('common.it_specialist')}</Link>
                        </h3>
                        <p className="service-details__box__text">
                          {t('common.it_specialist_text')}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row gutter-y-30">
                  <div className="col-md-6 col-sm-12">
                    <img
                      src={security2}
                      className="service-details__sub-image"
                      alt=""
                    />
                  </div>

                  <div className="col-md-6 col-sm-12">
                    <div className="service-details__caption">
                      <h3 className="service-details__caption__title">{t('cyber_security.benefits_title')}</h3>
                      <ul className="service-details__caption__list">
                        <li>
                          <i className="fa fa-check-circle"></i>
                          {t('cyber_security.benefit_1')}
                        </li>
                        <li>
                          <i className="fa fa-check-circle"></i>
                          {t('cyber_security.benefit_2')}
                        </li>
                        <li>
                          <i className="fa fa-check-circle"></i>
                          {t('cyber_security.benefit_3')}
                        </li>
                        <li>
                          <i className="fa fa-check-circle"></i>
                          {t('cyber_security.benefit_4')}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>


                {/* <div className="row">
                  <div className="col-md-12">
                    <div
                      className="accrodion-grp service-details__accrodion"
                      data-grp-name="service-details__accrodion-1"
                    >
                      {faqs.map((item, index) => (
                        <div
                          className={`accrodion wow fadeInUp ${
                            index === clicked && "active"
                          }`}
                          key={index}
                          data-wow-delay="0ms"
                        >
                          <div className="accrodion-title">
                            <h4 onClick={() => setClicked(index)}>
                              {item.question}
                              <span className="accrodion-icon"></span>
                            </h4>
                          </div>
                          {index === clicked && (
                            <div className="accrodion-content">
                              <div className="inner">
                                <p>{item.answer}</p>
                              </div>
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                </div> */}
              </div>
              <div className="col-lg-4 sidebar-column">
                <ServiceSidebar />
              </div>
            </div>
          </div>
        </section>
      </Suspense>
    </>
  );
}

export default CyberSecurity